export function getDisplayedDuration(duration) {
    let hours = parseFloat(duration / 60);
    let minutes = parseFloat(duration % 60);
    const getUnit = (unit, count) => count > 1 ? `${unit}s` : unit;

    if (hours < 1) {
        return `${ minutes.toFixed(0) } ${ getUnit("minute", minutes) }`;
    } else if (minutes == 0) {
        return `${ hours.toFixed(0) } ${ getUnit("hour", hours) }`;
    }

    return `${ hours.toFixed(0) } ${ getUnit("hour", hours) } and ${ minutes.toFixed(0) } ${ getUnit("minute", minutes) }`
}